import { render, staticRenderFns } from "./DormitoryList.vue?vue&type=template&id=afbfad7e&"
import script from "./DormitoryList.vue?vue&type=script&lang=js&"
export * from "./DormitoryList.vue?vue&type=script&lang=js&"
import style0 from "./DormitoryList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports